/**
 * The app's short messages at the bottom of the screen (508). A save far down a phone's page said its result at the
 * page's top, out of sight; showToast says it where the person is looking. A success or a note closes itself; an
 * error or a warning stays until it is closed.
 */
export type ToastTone = 'success' | 'danger' | 'info' | 'warning'

export type ToastMessage = {
  id: number
  tone: ToastTone
  text: string
}

export const TOAST_EVENT = 'mp:toast'

let sequence = 0

export const showToast = (tone: ToastTone, text: string) => {
  if (typeof window === 'undefined' || !text) return
  sequence += 1
  window.dispatchEvent(
    new CustomEvent<ToastMessage>(TOAST_EVENT, {detail: {id: sequence, tone, text}})
  )
}
